'use strict';

// TODO: remove, semver-major

module.exports = require('get-intrinsic');



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/GetIntrinsic.js
 ** module id = 847
 ** module chunks = 0
 **/